<template>
  <div>
    <div class="p-3">{{ $t('order') }} # {{ order.scancode }} | {{ source }}</div>
    <div class="px-3 pb-3">
      <font-awesome-icon icon="clock" size="lg" class="mr-2 text-primary" />
      <span v-if="order.shippingMethodDisplayName"
        ><strong>{{ order.shippingMethodDisplayName }}</strong></span
      >
      <span v-if="order.reservationStart && order.reservationEnd"
        ><strong>
          {{ order.reservationStart | dayOfWeek }}
          {{ order.reservationStart | formatTime }} -
          {{ order.reservationEnd | formatTime }}</strong
        ></span
      >
    </div>
    <div class="d-flex flex-column justify-content-between align-items-start px-3 wc-section">
      <div class="mr-3">
        <div>
          <b>{{ $t('orderPlaced') }}</b>
        </div>
        <div>{{ order.endTime | formatDateTime }}</div>
      </div>
      <div>
        <div>
          <b>{{ $t('orderTotal') }}</b>
        </div>
        <div>
          <span v-if="order.total">{{ order.total | currency }}</span>
          <span v-if="!order.total">{{ $t('notAvailableAbbr') }}</span>
        </div>
      </div>
    </div>
    <div class="px-3 py-2 d-flex justify-content-between">
      <div>
        <b>{{ $t('orderStatus') }}</b
        >: {{ order.status.label }}
      </div>
      <div class="d-flex justify-content-center">
        <button
          v-if="order.editable"
          class="btn btn-primary mr-3"
          data-btn="cancelOrder"
          ref="modalTriggerButton"
          @click="cancelOrder(order)"
        >
          {{ $t('cancelOrder') }}
        </button>

        <WCEditOrderButton
          v-if="order.editable && this.$configuration.allowEditOrder"
          data-btn="EditOrder"
          class="btn btn-primary"
          ref="modalTriggerButton"
          @editOrder="editOrder(order)"
        />
      </div>
    </div>

    <WCOrderTrackerMobile
      v-if="order.status.stage >= 0 && order.status.stage < 3"
      :status="order.status"
    />

    <div class="px-3 py-2 my-3 wc-section">
      <b>{{ $t('orderItems') }}</b>
    </div>

    <div class="px-3">
      <WCBuyItAgainSection :items="order.lineItems" :showQuantity="true" />
    </div>
  </div>
</template>

<script>
import WCOrderTrackerMobile from '@/modules/orders/components/WCOrderTrackerMobile/WCOrderTrackerMobile.vue';
import ProductImageInfoMixin from '@/mixins/ProductImageInfoMixin';
import OrderPanelMixin from '@/modules/orders/mixins/OrderPanelMixin';
import WCBuyItAgainSection from '@/modules/user/components/WCBuyItAgainSection/WCBuyItAgainSection.vue';
import WCEditOrderButton from '../WCOrderPanel/WCEditOrderButton/WCEditOrderButton.vue';

export default {
  components: { WCOrderTrackerMobile, WCEditOrderButton, WCBuyItAgainSection },
  mixins: [ProductImageInfoMixin, OrderPanelMixin],
  computed: {
    source() {
      return this.order.source === 'Web Cart' ? 'Online Purchase' : 'In Store Purchase';
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-section {
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
}

.wc-item {
  flex: 0 45%;
}

.wc-item-image {
  width: rem(50px);
  height: rem(50px);
  object-fit: scale-down;
}
</style>
